// This function allow to reference async chunks
__webpack_require__.miniCssF = function(chunkId) {
	// return url for filenames based on template
	return "css/" + chunkId + "." + {"508":"f86dff4b","988":"e6ea80ce"}[chunkId] + ".css";
};